import { render, staticRenderFns } from "./AccountPlanSetting.vue?vue&type=template&id=81908350"
import script from "./AccountPlanSetting.vue?vue&type=script&lang=js"
export * from "./AccountPlanSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports